import { h, Host, } from '@stencil/core';
import { send, mediaGalleryPopupEvent, triggerCtaClickEvent, isAnalyticsEnabled, ExtraBadgesCharId } from '@pes-ui/utils';
import { isBrowser } from '../../../globals/utils';
import { Se360widget, Se3dWidget } from '../../UI/se-widgets/se-widgets';
import { updateWidgetScript, removeWidgetScript } from './widget-script';
import { ThumbnailItem } from './thumbnail-item/thumbnail-item';
import { CommercialMessage } from './commercial-message/commercial-message';
import { createSlides, ItemType, createMediaGalleryGAEventParams } from './utils';
import YoutubePlayIcon from './icons/youtube-play.svg';
import ZoomInfoStatus from './ZoomInfoStatus';
const CLICK_ON_BANNER_INTERVAL_IN_MS = 150;
export class MediaGallery {
  didPopupClose() {
    this.closeDialog();
  }
  didZoomOpen(event) {
    this.zoomOpen = event.detail;
  }
  constructor() {
    this.startTime360ViewClick = 0;
    this.endTime360ViewClick = 0;
    this.selectedType = ItemType.IMG;
    this.selectedMedia = 0;
    this.selectedPrevious = null;
    this.galleryItems = [];
    this.maxThumbnails = 6;
    this.thumbnails = [];
    this.imageCTA = null;
    this.videoCTA = null;
    this.miaLogo = null;
    this.onMouseDown = () => {
      this.startTime360ViewClick = new Date().getTime();
    };
    this.onMouseUp = () => {
      this.endTime360ViewClick = new Date().getTime();
    };
    this.handle360ViewClick = () => {
      if (this.endTime360ViewClick - this.startTime360ViewClick < CLICK_ON_BANNER_INTERVAL_IN_MS) {
        this.openDialog();
      }
    };
    this.setPreviousMedia = () => {
      if (this.selected < this.thumbnailsImageCount) {
        this.selectedPrevious = this.selected;
      }
    };
    this.openDialog = () => {
      this.dialogOpen = true;
      if (isAnalyticsEnabled()) {
        send(mediaGalleryPopupEvent);
      }
    };
    this.closeDialog = () => {
      this.dialogOpen = false;
      if (this.selectedPrevious !== null) {
        this.selected = this.selectedPrevious;
        this.selectedPrevious = null;
      }
    };
    this.renderCommercialMessage = () => {
      return (this.items.productStatus.commercialColor && (h(CommercialMessage, { color: this.items.productStatus.commercialTextColor, backgroundColor: this.items.productStatus.commercialColor, message: this.items.productStatus.commercialMessage })));
    };
    this.renderMobileSlide = (item, index) => {
      const handleClick = () => {
        this.openDialog();
        this.selected = index;
      };
      return (h("div", { class: "mobile-media__slide" }, item.type === ItemType.IMG && [
        item.isMainImage && (h("pes-brand-logos", { miaLogo: this.miaLogo, greenPremiumLogo: this.items.greenPremiumLogo, pdsLogo: this.items.pdsLogo, energyStarLogo: this.items.energyStarLogo })),
        h("img", { src: item.preview, onClick: handleClick, alt: item.title, width: "284", height: "284", class: "mobile-media__slide-image" }),
      ], (item.type === ItemType.ROTATION || item.type === ItemType.GEOMETRIC) && (h("div", { class: "mobile-media__slide-360", style: { backgroundImage: `url(${this.galleryItems[0].preview})` }, onClick: handleClick }, h("div", { class: "mobile-media__slide-360-wrapper" }, h("img", { class: "mobile-media__slide-360-icon", src: item.preview, alt: "" }), h("div", { class: "mobile-media__slide-360-title" }, this.items.pdpTapToViewLabel)))), item.type === ItemType.VIDEO && (h("div", { class: "mobile-media__slide-video", onClick: handleClick }, h("div", { class: "mobile-media__slide-play-btn" }, h("div", { class: "mobile-media__slide-play-icon", innerHTML: YoutubePlayIcon })), h("img", { src: item.thumbnailUrl, onClick: handleClick, alt: item.title, class: "mobile-media__slide-image" })))));
    };
    this.render = () => {
      var _a, _b, _c;
      if (!this.items)
        return;
      return (h(Host, { class: {
          'media-gallery': true,
          'media-gallery--dialog-open': this.dialogOpen,
        } }, h("div", { class: "desktop-media" }, h("div", { class: "media-content" }, h("div", { class: "media-image" }, this.selectedType !== ItemType.ROTATION
        && this.selectedType !== ItemType.GEOMETRIC && (h("pes-media-gallery-zoom", { onClick: this.openDialog, imageSource: this.galleryItems[this.selectedMedia].src, imagePreviewSource: this.selectedType === ItemType.IMG
          ? this.galleryItems[this.selectedMedia].preview
          : this.galleryItems[this.selectedMedia].src, imageTitle: this.galleryItems[this.selectedMedia].title, parentWidth: this.parentWidth, showHighResImageNotAvailableHint: !this.galleryItems[this.selectedMedia].isHighResImageAvailable
          && this.selectedType === ItemType.IMG, imageLoadingErrorLabel: this.items.gallery.labels.imageLoadingErrorLabel, miaLogo: this.miaLogo, greenPremiumLogo: this.items.greenPremiumLogo, pdsLogo: this.items.pdsLogo, energyStarLogo: this.items.energyStarLogo, showBrandLogos: this.galleryItems[this.selectedMedia].isMainImage })), h("div", { onClick: this.openDialog, onMouseEnter: () => {
          this.zoomOpen = true;
        }, onMouseLeave: () => {
          this.zoomOpen = false;
        } }, h(ZoomInfoStatus, { zoomOpen: this.zoomOpen, showHint: this.showHint, selectedType: this.selectedType, openDialog: this.openDialog })), (this.selectedType === ItemType.ROTATION
        || this.selectedType === ItemType.GEOMETRIC) && (h("div", { class: "media-image__360", onClick: this.handle360ViewClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onMouseEnter: () => (this.showHint = true), onMouseLeave: () => (this.showHint = false) }, this.selectedType === ItemType.ROTATION && (h(Se360widget, { uri: (_a = this.galleryItems[this.selectedMedia]) === null || _a === void 0 ? void 0 : _a.src, scale: "380,380" })), this.selectedType === ItemType.GEOMETRIC && (h(Se3dWidget, { uri: (_b = this.galleryItems[this.selectedMedia]) === null || _b === void 0 ? void 0 : _b.src })))), this.renderCommercialMessage(), h("span", { class: "zoom__info-label" }, this.renderZoomInfoLabel()))), h("div", { class: "thumbnails__wrapper" }, this.thumbnails.map((item, index) => (h(ThumbnailItem, { item: item, active: this.selected === index, handleMouseEnter: () => {
          this.selected = index;
          this.selectedPrevious = null;
          triggerCtaClickEvent(createMediaGalleryGAEventParams(item));
        } }))), this.imageCTA && (h(ThumbnailItem, { item: this.imageCTA, active: this.selected === this.thumbnailsImageCount, handleMouseEnter: () => {
          this.setPreviousMedia();
          this.selected = this.thumbnailsImageCount;
          triggerCtaClickEvent(createMediaGalleryGAEventParams(this.imageCTA));
        }, handleClick: () => {
          this.openDialog();
        } })), this.videoCTA && (h(ThumbnailItem, { item: this.videoCTA, label: (_c = this.items.gallery.labels.videosNumber) === null || _c === void 0 ? void 0 : _c.replace('#number#', `${this.videoCount}`), active: this.selected === this.thumbnailsCount, handleMouseEnter: () => {
          this.setPreviousMedia();
          this.selected = this.thumbnailsCount;
          triggerCtaClickEvent(createMediaGalleryGAEventParams(this.videoCTA));
        }, handleClick: () => {
          this.selected = this.videoFirstIndex;
          this.openDialog();
        } })))), h("div", { class: "mobile-media", style: { minHeight: this.galleryItems.length > 1 ? '305px' : '284px' } }, [
        isBrowser() && (h("pdp-slider", { class: "mobile-media__slider", key: "browser", "show-pointers": "true", "show-buttons": "false", "small-point": "true", "short-carousel-pagination": "true", "childs-class-name": ".mobile-media__slide", sliderWidth: 284, activeSlide: this.selected }, this.galleryItems.map((item, index) => {
          return this.renderMobileSlide(item, index);
        }))),
        !isBrowser() && (h("pdp-slider", { class: "mobile-media__slider", key: "server", "show-pointers": "true", "show-buttons": "false", "small-point": "true", "short-carousel-pagination": "true", "childs-class-name": ".mobile-media__slide", sliderWidth: 284, activeSlide: this.selected }, this.renderMobileSlide(this.galleryItems[0], 0))),
      ], this.renderCommercialMessage()), this.dialogOpen && isBrowser() && (h("pes-media-gallery-popup", { items: this.items, open: this.dialogOpen, productLabel: this.productId, selectedMedia: this.selected }))));
    };
    this.items = undefined;
    this.productId = undefined;
    this.parentWidth = undefined;
    this.selected = 0;
    this.dialogOpen = false;
    this.zoomOpen = false;
    this.showHint = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  updateGalleryItems() {
    var _a, _b;
    this.galleryItems = createSlides(this.items);
    const images = this.galleryItems.filter(({ type }) => type !== ItemType.VIDEO);
    const imagesCount = images.length;
    this.videoCount = this.galleryItems.length - imagesCount;
    this.thumbnailsCount = imagesCount < this.maxThumbnails
      ? imagesCount + 1
      : this.maxThumbnails;
    this.thumbnailsImageCount = this.thumbnailsCount;
    if (this.videoCount) {
      this.videoFirstIndex = this.galleryItems.findIndex(({ type }) => type === ItemType.VIDEO);
      this.thumbnailsImageCount--;
      this.videoCTA = { type: ItemType.VIDEO };
    }
    else {
      this.videoCTA = null;
    }
    if (imagesCount > this.thumbnailsImageCount) {
      this.imageCTA = Object.assign(Object.assign({}, images[--this.thumbnailsImageCount]), { title: `+ ${imagesCount - this.thumbnailsImageCount}` });
    }
    else {
      this.imageCTA = null;
    }
    this.miaLogo = (_b = (_a = this.items.extraBadges) === null || _a === void 0 ? void 0 : _a.find(({ charId }) => {
      return charId === ExtraBadgesCharId.ATS_MADE_IN_AMERICA;
    })) === null || _b === void 0 ? void 0 : _b.url;
    this.thumbnails = images.slice(0, this.thumbnailsImageCount);
    this.selected = 0;
    updateWidgetScript(this.items);
  }
  componentWillLoad() {
    if (this.items) {
      this.updateGalleryItems();
    }
  }
  componentWillRender() {
    var _a;
    this.selectedMedia = this.selected;
    if (this.selectedPrevious !== null && this.selected >= this.thumbnailsImageCount) {
      this.selectedMedia = this.selectedPrevious;
    }
    this.selectedType = (_a = this.galleryItems[this.selectedMedia]) === null || _a === void 0 ? void 0 : _a.type;
  }
  disconnectedCallback() {
    removeWidgetScript();
  }
  onItemsChange() {
    this.updateGalleryItems();
  }
  renderZoomInfoLabel() {
    if (this.zoomOpen || this.showHint)
      return this.items.expandImgLabel;
    if (this.selectedType === ItemType.GEOMETRIC
      || this.selectedType === ItemType.ROTATION) {
      return this.items.pdpDragToRotateLabel;
    }
    return this.items.rollOverImgLabel;
  }
  static get is() { return "pes-media-gallery"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["media-gallery.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["media-gallery.css"]
    };
  }
  static get properties() {
    return {
      "items": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductMedia",
          "resolved": "{ __typename?: \"ProductMedia\"; dblTapImgLabel?: string; expandImgLabel?: string; image360?: Image360; imgLabel?: string; nodeName?: string; pdpDragToRotateLabel?: string; pdpImage360Label?: string; pdpTapToViewLabel?: string; rollOverImgLabel?: string; videoLabel?: string; videos?: ProductVideoLink[]; gallery?: Gallery; zoomPictureDesktop?: ImageLink; zoomPictureMobile?: ImageLink; zoomPicturePreview?: ImageLink; zoomPictureThumbnail?: ImageLink; alternativeImages?: AlternativeImage[]; productStatus?: ProductStatus; greenPremiumLogo?: LogoInfo; pdsLogo?: LogoInfo; energyStarLogo?: LogoInfo; extraBadges?: ExtraBadges[]; ctaMainImage?: MediaGalleryClickEventParamsType; }",
          "references": {
            "ProductMedia": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product media, including images, video, labels"
        }
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Id of product"
        },
        "attribute": "product-id",
        "reflect": false
      },
      "parentWidth": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The width of parent component for calculating zoom viewer width."
        },
        "attribute": "parent-width",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "selected": {},
      "dialogOpen": {},
      "zoomOpen": {},
      "showHint": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "items",
        "methodName": "onItemsChange"
      }];
  }
  static get listeners() {
    return [{
        "name": "didCloseDialog",
        "method": "didPopupClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "didClose",
        "method": "didPopupClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "didZoomOpen",
        "method": "didZoomOpen",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
